import { SEO } from "@/components/common/SEO";
import { Container } from "@/components/ui/Container";
import { Section } from "@/components/ui/Section";
import { SectionHeading } from "@/components/ui/SectionHeading";
import { PageHero } from "@/components/sections/PageHero";
import { IconCardGrid } from "@/components/sections/IconCardGrid";
import { ContactSection } from "@/components/sections/ContactSection";
import { CONTACT } from "@/data/content";

export default function Contact() {
  return (
    <>
      <SEO
        title="Contact"
        description="Partner with MedCore Research. We welcome collaboration with clinical sites, physicians, pharma and biotech companies, sponsors, CROs, and research partners."
        path="/contact"
      />
      <PageHero
        eyebrow="Contact Us"
        title={CONTACT.heading}
        description={CONTACT.intro}
      />

      <Section muted data-testid="contact-options-section">
        <Container>
          <SectionHeading
            eyebrow="How We Can Help"
            title="Choose the option that fits you best"
          />
          <div className="mt-12">
            <IconCardGrid
              items={CONTACT.options}
              columns={3}
              tone="emerald"
              cardTestId="contact-option-card"
            />
          </div>
        </Container>
      </Section>

      <ContactSection />
    </>
  );
}
